

import React from "react";
import * as animationData from "./Download_Lottie.json";
import "./Download_Lottie.css";
import Lottie from "react-lottie";

export const Download_Lottie = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">
      <div className="success_div">
        <Lottie className="me-auto lottie" options={defaultOptions} />
      </div>
    </section>
  );
};
